import { useState, useEffect, useRef, useCallback } from 'react';
import { ReactComponent as CrownSvg } from '../../../assets/svg/crown.svg';
import request from '../../../lib/request';

const AllChallenges = ({ handleClickChallenge }) => {
  const [challenges, setChallenges] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef();

  const lastChallengeElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const getChallenges = async () => {
    try {
      setLoading(true);
      const { result } = await request.get(
        `/challenge/list?page=${page}&count=10`
      );

      if (result) {
        setChallenges((prevChallenges) => [...prevChallenges, ...result]);
        setHasMore(result.length === 10);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getChallenges();
  }, [page]);

  return (
    <div className='px-4'>
      <h2 className='text-white font-bold mb-2'>All Challenges</h2>
      <div className='grid grid-cols-3 gap-2'>
        {challenges.map((challenge, index) =>
          challenges.length === index + 1 ? (
            <div
              ref={lastChallengeElementRef}
              key={index}
              className='aspect-[2/3] w-[20vw] min-w-[108px] max-w-[140px] relative'
              onClick={handleClickChallenge(challenge.id)}
            >
              <img
                src={challenge.bannerUrl}
                alt='poster'
                className='object-cover object-center w-full h-full rounded-md'
              />
              {challenge.premium && (
                <div className='absolute top-0 left-0 bg-accent px-1 py-[1px] rounded-tl-md rounded-br-md'>
                  <CrownSvg className='size-3' />
                </div>
              )}
            </div>
          ) : (
            <div
              key={index}
              className='aspect-[2/3] w-[20vw] min-w-[108px] max-w-[140px] relative'
              onClick={handleClickChallenge(challenge.id)}
            >
              <img
                src={challenge.bannerUrl}
                alt='poster'
                className='object-cover object-center w-full h-full rounded-md'
              />
              {challenge.premium && (
                <div className='absolute top-0 left-0 bg-accent px-1 py-[1px] rounded-tl-md rounded-br-md'>
                  <CrownSvg className='size-3' />
                </div>
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default AllChallenges;
